/**
 * Enum containing different error states for `<dx-combobox>` element.
 */
export var ComboboxErrorType;
(function (ComboboxErrorType) {
    ComboboxErrorType["NO_SEARCH_RESULT"] = "NO_SEARCH_RESULT";
    ComboboxErrorType["NO_ERROR"] = "NO_ERROR";
})(ComboboxErrorType || (ComboboxErrorType = {}));
